<fieldset class="bordas" [style]="'width: auto'">
    <div>
        <div fxLayout="column" fxFlex="90%">
            <div fxLayout="row" fxLayoutGap="20px">
                <div ngModelGroup="comboMetaAtendimento_{{idRandomico}}" fxFlex="100">
                    <combo-meta-objetivo [showDisplayId]="false"
                                         [obrigatorio]="true"
                                         [selecionado]="meta.metaObjetivo"
                                         (valorChange)="onValorChangeMeta($event)">
                    </combo-meta-objetivo>
                </div>
            </div>
        </div>

        <div fxLayout="column" fxFlex="10%" fxLayoutAlign="center center">
            <button mat-icon-button *ngIf="perfilAcesso.deleta" (click)="deletar()" style="padding: 0px;">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
    </div>
</fieldset>